import React from 'react';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { GridDivider } from '@sharedComponents/Separators';
import { StyledBasicWrapper } from '@styles/generalStyles';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';
import { CypressTestNamespace } from '@utils/test';

import { useCartPageContext } from '../../context';

import { LoyaltyDiscountItem } from './LoyaltyDiscountItem';
import { StyledLoyaltyWrapper } from './styled';
import { getStandardBenefits } from './utils';

export const LoyaltyDiscountItemWrapper: ReactFCV = () => {
  const {
    state: {
      benefits: { loyalties },
    },
  } = useCartPageContext();

  const {
    applicationSettings: { features, secondaryCurrency },
  } = useApplicationRuntimeContext();

  const isDualPriceLayout = Boolean(secondaryCurrency);
  const items = getStandardBenefits(loyalties);

  if (!features.benefits) {
    return null;
  }

  return (
    <StyledBasicWrapper
      data-testid="loyalty-discount-item-wrapper"
      className={CypressTestNamespace.ECartPageBenefits.BENEFITS_SECTION}>
      {items.map((benefit) => (
        <>
          <GridDivider data-testid="benefit-divider" color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />
          <StyledLoyaltyWrapper data-testid="benefit-loyalty-wrapper">
            <LoyaltyDiscountItem
              isDualPriceLayout={isDualPriceLayout}
              key={`${benefit.discountListName}_${benefit.discountType}_${benefit.priceValue}`}
              {...benefit}
            />
          </StyledLoyaltyWrapper>
        </>
      ))}
    </StyledBasicWrapper>
  );
};
